/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'remote': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M42.5 34.898L48.602 41c-14.2 14.199-14.2 37.398 0 51.699L42.5 98.801c-17.602-17.7-17.602-46.301 0-63.902zM53.898 46.3c-11.301 11.301-11.301 29.7 0 41L60 81.2c-3.899-3.899-6-9-6-14.398 0-5.5 2.101-10.602 6-14.398L53.898 46.3zM107.5 34.898L101.398 41c14.2 14.199 14.2 37.398 0 51.699l6.102 6.102c17.602-17.7 17.602-46.301 0-63.902zM96.102 46.3L90 52.398c3.899 3.898 6 9 6 14.398 0 5.5-2.101 10.602-6 14.398l6.102 6.102c11.297-11.297 11.297-29.695 0-40.996zM91.7 114.5c0-7.602-5.2-14-12.2-15.899V79.2c5.102-1.8 8.7-6.699 8.7-12.398 0-7.3-5.898-13.199-13.2-13.199-7.3 0-13.198 5.899-13.198 13.2 0 5.699 3.601 10.601 8.7 12.397v19.398c-6.802 2-11.802 8.301-11.802 15.801V117h33.102v-2.5H91.7z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
